import { Component, Directive, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ButtonAppearanceET } from '@liberty-financial/ng-components/lib/components/button/button.enum';

@Directive({
  selector: 'app-details-content'
})
export class DetailsContent {
}

@Component({
  selector: 'app-details-modal',
  templateUrl: './details-modal.component.html',
  styleUrls: ['./details-modal.component.scss']
})
export class DetailsModalComponent {

  // inputs
  @Input() title: string = '';
  @Input() subtitle: string | null = null;
  @Input() buttonStyle: ButtonAppearanceET = 'action';
  @Input() form: UntypedFormGroup | null = null;
  @Input() showBack: boolean = false;
  @Input() showNext: boolean = false;
  @Input() showSave: boolean = true;
  @Input() saveLabel: string = "Save";
  @Input() cancelLabel: string = "Cancel";
  @Input() backLabel: string = "Back";
  @Input() nextLabel: string = "Next";
  @Input() warningMessage: string = 'Please correct the highlighted errors';

  // event emitters
  @Output() cancel = new EventEmitter();
  @Output() save = new EventEmitter();
  @Output() back = new EventEmitter();
  @Output() next = new EventEmitter();

  private saveClicked: boolean = false;

  constructor() { 
  }

  public onNext(): void {
    this.next.emit();
  }

  public onBack(): void {
    this.back.emit();
  }

  public onCancel(): void {
    this.cancel.emit();
  }

  public onSave(): void {
    this.saveClicked = true;
    if (!this.isDirty()) return;

    if (this.form != null && this.form.invalid) {
      this.form.markAllAsTouched();
    }

    this.save.emit();
  }

  public isDirty(): boolean {
    return this.form != undefined && this.form != null && this.form.dirty;
  }

  public isInvalid(): boolean {
    return this.form != undefined && this.form != null && this.saveClicked && this.form.invalid;
  }
}
